// /andrea_map — broadcast overlay surface for the results map.
//
// White page background + light-grey map card. The ResultsMap renders
// in its `chroma` variant (class name retained for compatibility) —
// suppresses hover tooltips, the legend, and card chrome so the map
// reads as a clean overlay. The page used to be chroma-green
// (#00B140) for switcher keying; per editor we now ship a white
// page so the overlay can be composited into white-backed slides /
// graphics packages directly.
//
// No Header, no Footer, no NewsTicker — totally flat for clean
// capture in a screen-share / NDI source.

import ResultsMap from './Results/ResultsMap';

export default function AndreaMapPage() {
  return (
    <div
      style={{
        background: '#ffffff',
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // Padding stops the map from kissing the viewport edges so
        // the grey card has clean breathing room on the white page.
        padding: '24px',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          // Sized to be readable when shrunk to a corner overlay on
          // a 1080p / 720p broadcast feed — too small here and the
          // map labels won't survive the downscale.
          width: '100%',
          maxWidth: 900,
          // Background matches the outer page so the card visually
          // disappears — map sits on a single flat white surface.
          background: '#ffffff',
        }}
      >
        <ResultsMap title="Live results map" variant="chroma" />
      </div>
    </div>
  );
}
